import React from 'react'
import CurrentAccountValue from '../../../CurrentAccountValue/CurrentAccountValue'

import Viemo from '../../../../Vimeo/Viemo';
import { VIMEO_ICON_TYPE } from '../../../../../funcs/utils';
import { VIEMO_COMPOUND, VIEMO_LEARN_MORE, VIEMO_MARKETS, VIEMO_POTENTIAL } from '../../../../../constants/constants';
import PotentialLabel from '../../../PotentialLabel/PotentialLabel';
import Contributions from '../../../Contributions/Contributions';
import InternalRateOfReturn from '../../../InternalRateOfReturn/InternalRateOfReturn';
import NumInvestmentYears from '../../../NumInvestmentYears/NumInvestmentYears';
import NumDistributionYears from '../../../NumDistributionYears/NumDistributionYears';

const TaxableDistribution = ({data}) => {
    const {
        initialPortfolioValue,
        numInvestmentYears,
        numDistributionYears,
        potentialAmount,
        contribution,
        investmentYearsText,
        potentialAmountText,
        distributionYearsText,
    } = data;

    if(!data) return null;

    return (
        <div align={"left"} >
            <CurrentAccountValue value={initialPortfolioValue} />
            <NumInvestmentYears value={numInvestmentYears} infoText={investmentYearsText}/>
            <NumDistributionYears value={numDistributionYears} infoText={distributionYearsText}/>
            <Contributions value={contribution} />
            <InternalRateOfReturn />

            <PotentialLabel 
				label={"Potential Amount"} 
				value={potentialAmount}
				infoText={potentialAmountText}
			/>
            <div style={{marginTop: '16px'}}>
				{/* video dump */}
				<Viemo icon={VIMEO_ICON_TYPE.AVATAR} videoId={VIEMO_LEARN_MORE} label={'Learn More About'}/>
				<Viemo icon={VIMEO_ICON_TYPE.PRIMER} videoId={VIEMO_POTENTIAL} label={'Potential'}/>
				<Viemo icon={VIMEO_ICON_TYPE.PRIMER} videoId={VIEMO_COMPOUND} label={'Compound Interest'}/>
				<Viemo icon={VIMEO_ICON_TYPE.PRIMER} videoId={VIEMO_MARKETS} label={'Markets'}/>
			</div>
        </div>
    )
}

export default TaxableDistribution;